import classnames from 'classnames';
import styles from './OverlayPanel.module.scss';
import { DesktopVariants } from './types';
export const levelClasses = {
    1: styles.level1,
    2: styles.level2,
    3: styles.level3,
};
export const desktopVariantClasses = {
    [DesktopVariants.HIDDEN]: styles.variantHidden,
    [DesktopVariants.FULLSCREEN]: styles.variantFullscreen,
    [DesktopVariants.POPUP]: styles.variantPopup,
    [DesktopVariants.OVERLAY_FORM]: styles.variantOverlayForm,
    [DesktopVariants.OVERLAY_FORM_LARGE]: classnames(styles.variantOverlayForm, styles.large),
};
